<template>
    <div class="base-top-menuNav base-flex">
        <div class="base-logo">
            <img src="@/assets/img/logo.png" alt="logo">
        </div>
        <div role="navigation" class="base-menuNav base-flex-between" tabindex="0">
            <div class="base-menu base-flex" role="menu" tabindex="0">
                <div v-for="item in $store.getters.menus" :key="item.title" @click="handleChangeMenu(item)" @keyup.enter="handleChangeMenu(item)" :class="className(item)" class="menuitem" role="menuitem" tabindex="0">
                    <span>{{ $tran(item.Ename) }}</span>
                </div>
            </div>
            <div :aria-label="$tran('Personal Center')" class="base-user base-flex" tabindex="0">
                <div @click="handleLogout()" @keyup.enter="handleLogout()" role="button" :aria-label="$tran('Exit')" class="user-logout base-flex" tabindex="0">
                    <img src="@/assets/img/logout.png" alt="">
                    <span class="base-bText14">{{ $tran('Exit') }}</span>
                </div>
                <div @click="showDialog" @keypress.enter="showDialog" role="button" :aria-label="$tran('Personal center image button')" class="user-center" tabindex="0">
                    <img src="@/assets/img/userExample.png" alt="">
                </div>
            </div>
        </div>
        <cus-dialog :title="$tran('Settings')" class="exportDialog" :visible="userProfile" :close="closeUserProfile">
            <div class="dialog-content">
                <div class="languageSelect base-flex"  >
                    <div class="base-formItem">
                        <span>{{ $tran('Language') }}</span>
                        <el-select ref="menuSelect" v-model="curLanguage" @change="changeLanguage" :placeholder="$tran('Select the x', 'Language')">
                            <el-option value="zh" :label="$tran('Simplified Chinese')"></el-option>
                            <el-option value="en" :label="$tran('English')"></el-option>
                            <el-option value="zhHant" :label="$tran('Traditional Chinese')" v-if="setLangs" ></el-option>
                            <el-option value="fr" :label="$tran('French')" v-if="setLangs"></el-option>
                            <el-option value="de" :label="$tran('German')" v-if="setLangs"></el-option>
                            <el-option value="it" :label="$tran('Italian')" v-if="setLangs"></el-option>
                            <el-option value="es" :label="$tran('Spanish')" v-if="setLangs"></el-option>
                            <el-option value="ja" :label="$tran('Japanese')" v-if="setLangs"></el-option>
                            <el-option value="th" :label="$tran('Thai')" v-if="setLangs"></el-option>
                            <el-option value="ukUa" :label="$tran('Ukrainian')" v-if="setLangs"></el-option>
                            <el-option value="ruRu" :label="$tran('Russian')" v-if="setLangs"></el-option>
                            
                        </el-select>
                    </div>
                </div>
                <div class="userInfoForm">
                    <div class="base-flex">
                        <div class="avatar base-formItem base-flex-grow1">
                            <span>{{ $tran('Profile Picture') }}</span>
                            <img src="@/assets/img/userExample.png" alt="">
                        </div>
                        <div class="base-formItem">
                            <label for="role">{{ $tran('Role') }}</label>
                            <cus-input disabled :value="curRoleName" size="big" :placeholder="$tran('Please Enter your x', 'Role')" id="role" />
                        </div>
                    </div>
                    <div class="userInfo-disabled base-flex">
                        <div class="base-formItem">
                            <label for="username">{{ $tran('Username') }}</label>
                            <cus-input disabled :value="$store.getters.user.username" size="big" :placeholder="$tran('Enter your username')" id="username"/>
                        </div>
                        <div class="base-formItem">
                            <label for="nickname">{{ $tran('Full Name') }}</label>
                            <cus-input v-model="userInfo.nickname" size="big" :placeholder="$tran('Enter your full name')" id="nickname" />
                        </div>
                    </div>
                    <div class="changeFormItem">
                        <span tabindex="0" @click="updateUserInfo">{{ $tran('Edit Profile') }}</span>
                    </div>
                    <div class="base-flex">
                        <div class="base-formItem">
                            <label for="password">{{ $tran('Old Password') }}</label>
                            <cus-input v-model="userPassword.password" size="big" id="password" password :type="oldpasswordVisable ? 'password' : 'text'">
                                <i @click="oldpasswordVisable = !oldpasswordVisable" slot="suffix" :class="oldpasswordVisable ? 'el-icon-lock' : 'el-icon-unlock'"></i>
                            </cus-input>
                        </div>
                    </div>
                    <div class="userInfo base-flex" style="margin-top:6px;align-items: flex-start;">
                        <div class="base-formItem" style="font-size:12px;color:#999;">
                            <label for="newPassword"></label>
                            {{ $tran('Enter the original password') }}
                        </div>
                    </div>
                    <div class="userInfo base-flex" style="margin-top:10px;">
                        <div class="base-formItem">
                            <label for="newPassword">{{ $tran('New Password') }}</label>
                            <cus-input v-model="userPassword.newPassword" size="big" id="newPassword" password :type="passwordVisable ? 'password' : 'text'">
                                <i @click="passwordVisable = !passwordVisable" slot="suffix" :class="passwordVisable ? 'el-icon-lock' : 'el-icon-unlock'"></i>
                            </cus-input>
                        </div>
                        <div class="base-formItem">
                            <label for="newConfirmPassword">{{ $tran('Confirm Password') }}</label>
                            <cus-input v-model="userPassword.newConfirmPassword" size="big" id="newConfirmPassword" password :type="passwordVisable2 ? 'password' : 'text'">
                                <i @click="passwordVisable2 = !passwordVisable2" slot="suffix" :class="passwordVisable2 ? 'el-icon-lock' : 'el-icon-unlock'"></i>
                            </cus-input>
                        </div>

                    </div>
                    <div class="userInfo base-flex" style="margin-top:6px;align-items: flex-start;">
                        <div class="base-formItem" style="font-size:12px;color:#999;">
                            <label for="newPassword"></label>
                            {{$tran('Enter a new password。It must include at least three of the following：uppercase letters，lowercase letters，numbers，and special characters')}}
                        </div>
                        <div class="base-formItem" style="font-size:12px;color:#999;">
                            <label for="newPassword"></label>
                            {{ $tran('Enter the new password again。Two times of new password input is same') }}
                        </div>
                    </div>
                    <div class="changeFormItem">
                        <span tabindex="0" @click="updateUserPassword">{{ $tran('Change Password') }}</span>
                    </div>
                </div>
                <div class="userHelpInfo">
                    <div class="base-flex-center">
                        <div class="userHelpItem" v-for="i in userHelpArr" :key="i.link">
                            <span @click="skipLink(i)">{{ $tran(i.text) }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="version" id="appVersion">{{ appVersion }}</div>
        </cus-dialog>
    </div>
</template>

<script>
import { postRequest, putRequest } from '@/api/api';
import ElementUI from 'element-ui';
import { wPlaceHolder } from './wPlaceHolder';
export default {
    name: 'UserMenu',
    data() {
        return {
            appVersion:"",
            oldpasswordVisable:true,
            passwordVisable:true,
            passwordVisable2:true,
            curSelMenu: null,
            userProfile: false, // User configuration pop-up window
            userInfo: {}, // user information
            userPassword: {}, // User password information
            curLanguage: "", // current language
            userHelpArr: [
                { text: 'Lenovo Privacy Statement', link: 'https://www.lenovo.com.cn/statement/privacy.html', enLink: 'https://www.lenovo.com/us/en/privacy/' },
                { text: 'Lenovo Software License Agreement', link: 'https://support.lenovo.com/us/en/solutions/ht100141', enLink: 'https://support.lenovo.com/us/en/solutions/ht100141' },
                { text: 'Third-party notifications', link: './ThirdPartyNotice.html', enLink: './ThirdPartyNotice.html' }
            ], // User Help Array
            menus:[],
            setLangs:window.langs || false
        }
    },
    computed: {
        curRoleName() {
            let temRoleIdObj = this.$store.state.rolesEnum ? this.$store.state.rolesEnum.enumObj : {} , temRole = this.$store.getters.roles[0];
            return temRoleIdObj[temRole] ? this.$tran(temRoleIdObj[temRole].name) : '';
        },
    },
    methods: {
        className(item) {            
            return this.$route.path.includes(item.path) ? 'menuitem-isActive' : '';
        },
        handleChangeMenu(item) {
            this.curSelMenu = item.name;
            this.$router.push(item.path);
        },
        handleLogout() {
            postRequest('/system/auth/logout').then(res => {
                if(res && res.code === 200) {

                    this.$message.success(res.msg || 'Exited successfully');
                    window.removeCookie('token');
                    localStorage.removeItem("isGetToken") 
                    this.$router.push('/login');
                    //window.redirect("/login");
                    //window.location.href = "#/login";
                    //sessionStorage.token = '';
                }
            })
        },
        closeUserProfile() {
            this.userProfile = false;
        },
        showDialog() {
            this.curLanguage = this.$i18n.locale;
            this.userProfile = true;
            this.updateUserDialogInfo();
        },
        updateUserInfo() {
            if(!this.userInfo.nickname && this.userInfo.nickname !== 0) {
                this.$message.info('Please Enter your x', 'Full Name');
                return;
            }
            putRequest('/system/user/updateByToken', { username: this.$store.getters.user.username, id: this.$store.getters.user.id, ...this.userInfo }).then(res => {
                if(res && res.code === 200) {
                    this.$message.success('Operation successful');
                    this.$store.commit('updateLoginInfo', { ...this.$store.state.loginInfo, user: { ...this.$store.getters.user, nickname: this.userInfo.nickname } });
                }
            })
        },
        updateUserPassword() {
            if(!this.userPassword.password && this.userPassword.password !== 0) {
                this.$message.info('Please Enter your x', 'Old Password');
                return;
            }
            if(!this.userPassword.newPassword && this.userPassword.newPassword !== 0) {
                this.$message.info('Please Enter your x', 'New Password');
                return;
            }
            if(!this.userPassword.newConfirmPassword && this.userPassword.newConfirmPassword !== 0) {
                this.$message.info('Please Enter your x', 'Confirm Password');
                return;
            }
            if(this.userPassword.newConfirmPassword !== this.userPassword.newPassword) {
                this.$message.info('The two passwords entered do not match');
                return;
            }
            putRequest('/system/user/updatePassword', { id: this.$store.getters.user.id, ...this.userPassword }).then(res => {
                if(res && res.code === 200) {
                    this.$message.success('Operation successful');
                }
            })
        },
        updateUserDialogInfo() {
            this.userInfo = {
                nickname: this.$store.getters.user.nickname,
                // email: ''
            };
            this.userPassword = {
                //password: '',
                //newPassword: '',
                //newConfirmPassword: ''
            };
        },
        changeLanguage(value) {
            let curValue='zh'
            if(!window.langs){
               if(value!='en'&&value!='zh'){
                 curValue='en'
               }
            }
            curValue=value
            this.curLanguage = curValue;
            this.$i18n.locale = curValue;
            ElementUI.locale(this.$i18n.messages[curValue]);
            wPlaceHolder.locale(this.$i18n.messages[curValue]);
            try
            {
                window.global.MonitorList_languageChange();
            }
            catch(e)
            {}
            window.userLanguage = curValue;
        },
        skipLink(linkObj) {            
            window.open(this.$i18n.locale === 'zh' ? linkObj.link : linkObj.enLink, '_blank');
        },
        resizeFun() {
            this.$refs.menuSelect.visible = false;
        },
    },
    async created() {
        this.updateUserDialogInfo();
    },
    mounted() {

        window.addEventListener('resize', this.resizeFun);
        //document.querySelector("#appVersion").innerHTML = window.version;
        this.appVersion = window.version;
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeFun);
    },
}
</script>

<style lang="scss" scoped>
.base-top-menuNav {
    padding: 0 52px 0 32px;
    height: 72px;
    border-bottom: 1px solid #E2E8F0;
}

.base-logo {
    width: 40px;
    height: 40px;
    img {
        width: 40px;
        height: fit-content;
    }
}

.base-menuNav {
    margin-left: 30px;
    flex: 1;
}

.base-menu {
    height: 50px;
    box-sizing: border-box;
    //cursor: pointer;
    .menuitem {
        padding: 13px 2px; //padding: 13px 16px;
        height: 49px;
        vertical-align: middle;
        box-sizing: border-box;
        border-bottom: 4px solid transparent;
        overflow: hidden;
        white-space: nowrap;
        word-break: break-all;
        cursor: pointer;
        &+.menuitem {
            margin-left: 30px;
        }
        &.menuitem-isActive {
            color: var(--base-primary-color);
            border-color: var(--base-primary-color);
            /*background-color: #eff6ff;*/
            background-color: #eff6ff;
        }
        span {
            font-family: 'fontN';
        }
    }
}

.base-user {
    .user-logout {
        width: fit-content;
        height: 21px;
        line-height: 21px;
        cursor: default;
        img {
            width: 12.5px;
            height: fit-content;
            cursor: pointer;
        }
        span {
            margin-left: 10px;
        }
    }
    .user-center {
        margin-left: 10px;
        height: 42px;          
        img {
            width: 42px;
            height: fit-content;
        }
    }
}

::v-deep .exportDialog {
    .base-dialog-content {
        width: 928px;
    }
}


@media (max-width: 1200px) {
    ::v-deep .exportDialog {
        .base-dialog-outer {

            width: calc( 1360 / 1920 * 100% );

            max-height: calc( 860 / 919 * 100% );

        }
    }
}


.dialog-content {
    .base-input {
        width: 300px;
    }
    .base-formItem {
        width: calc( 50% - 25px / 2);
        display: flex;
        align-items: center;
        >span,
        >label {
            min-width: 156px;
            font-size: 14px;
            font-weight: bold;
            text-align: right;
            margin-right: 8px;
        }
    }
    >div {
        padding: 20px 50px;
        &:not(:last-of-type) {
            border-bottom: 1px solid #CBD5E1;
        }
    }
    .languageSelect {
    }
    .userInfoForm {
        >div {
            column-gap: 25px;
            &:not(:first-of-type) {
                margin-top: 40px;
            }
            &.changeFormItem {
                margin-top: 8px;
                font-size: 10px;
                text-align: right;
                color: var(--base-primary-color);
                span {
                    cursor: pointer;
                }
                &+div {
                    margin-top: 18px;
                }
            }
        }
        .avatar {
            height: 42px;
            column-gap: 0px;
            img {
                height: 42px;
            }
        }
    }
    .userHelpInfo {
        >div {
            height: 24px;
            .userHelpItem {
                padding: 2px 24px;
                &:not(:first-of-type) {
                    border-left: 1px solid var(--base-primary-color);
                }
                span {
                    cursor: pointer;
                    color: var(--base-primary-color);
                    font-size: 14px;
                }
            }
        }
    }
}
.version{
        height: 30px;
        line-height: 30px;
        text-align: center;
        vertical-align: top;
        font-size: 14px;
        color:#777;
        padding-top:0px !important;
        padding-bottom:20px !important;
}
</style>
<style>
input[type="password"]::-ms-reveal{
  display: none;
}
input[type="password"]::-ms-clear{
  display: none;
}
</style>